import { useContext, useEffect, useState } from "react";
import { Box, Typography } from "@mui/material";
import { AlertModalCheckIcon } from "../../../../assets";
import { BaseAlertModal } from "../../../../components/modal/alert";
import { AppLayout } from "../../../../containers/layout/app";
import { EditCustomerWrapper } from "./styled";
import { OnboardCustomerAccountFormFieldsType } from "../../../../types/container.type";
import Cookies from "universal-cookie";
import { useNavigate, useParams } from "react-router-dom";
import { AppContext } from "../../../../context/appContext";
import { updateCustomerService } from "../../../../utils/api/customerservice/customerlist/updateCustomer";
import { UpdateCustomer } from "../../../../containers/form/updatecustomer";

export const EditCustomer = () => {
    const cookies = new Cookies();
    const TOKEN = cookies.getAll().TOKEN;

    const navigate = useNavigate();
    const { id = "" } = useParams();
    const { setActiveNavItem } = useContext(AppContext);

    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState<string | null>(null);
    const [isAlertModalOpen, setIsAlertModalOpen] = useState(false);
    const [formDetails, setFormDetails] = useState<OnboardCustomerAccountFormFieldsType>({
        firstName: "",
        middleName: "",
        lastName: "",
        BVN: "",
        email: "",
        gender: " ",
        dob: "",
        occupation: "",
        address: "",
        country: "",
        state: " ",
        lga: " ",
        phone: "",
        branch: " ",
        accountManager: " ",
        status: " ",
        validId: "",
        customerLevel: " ",
        activateEmail: false,
        activateSMS: false,
        autoChargeSMS: false,
        allowWithdrawal: false,
        passport: "",
        signature: "",
        nextOfKinFirstName: "",
        nextOfKinMiddleName: "",
        nextOfKinLastName: "",
        nextOfKinRelationship: " ",
        nextOfKinPhone: "",
        nextOfKinEmail: "",
        nextOfKinGender: " ",
        nextOfKinOccupation: "",
        nextOfKinResidentialAddress: "",
        savingsProduct: " ",
        tier: " ",
        group: " ",
    });

    useEffect(() => {
        setActiveNavItem("Customer Service");
    }, [setActiveNavItem]);

    const handleAlertModalPersist = () => {
        return setIsAlertModalOpen(true);
    };

    const handleAlertModalCallToActionClick = () => {
        setIsAlertModalOpen(false);
        return navigate(-1);
    };

    const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        setError(null);
        setIsLoading(true);
        const formData = new FormData();
        const data = {
            firstName: formDetails.firstName,
            middleName: formDetails.middleName,
            lastName: formDetails.lastName,
            email: formDetails.email,
            phone: formDetails.phone,
            BVN: formDetails.BVN,
            gender: formDetails.gender,
            dob: formDetails.dob,
            occupation: formDetails.occupation,
            address: formDetails.address,
            country: formDetails.country,
            state: formDetails.state,
            lga: formDetails.lga,
            branch: formDetails.branch,
            accountManager: formDetails.accountManager,
            status: formDetails.status,
            validId: formDetails.validId,
            customerLevel: formDetails.customerLevel,
            activateEmail: formDetails.activateEmail,
            activateSMS: formDetails.activateSMS,
            autoChargeSMS: formDetails.autoChargeSMS,
            allowWithdrawal: formDetails.allowWithdrawal,
            passport: formDetails.passport,
            signature: formDetails.signature,
            nextOfKinFirstName: formDetails.nextOfKinFirstName,
            nextOfKinMiddleName: formDetails.nextOfKinMiddleName,
            nextOfKinLastName: formDetails.nextOfKinLastName,
            nextOfKinRelationship: formDetails.nextOfKinRelationship,
            nextOfKinPhone: formDetails.nextOfKinPhone,
            nextOfKinEmail: formDetails.nextOfKinEmail,
            nextOfKinGender: formDetails.nextOfKinGender,
            nextOfKinOccupation: formDetails.nextOfKinOccupation,
            nextOfKinResidentialAddress: formDetails.nextOfKinResidentialAddress,
            savingsProduct: formDetails.savingsProduct,
            tier: formDetails.tier,
            group: formDetails.group,
        };
        Object.entries(data).forEach(([key, value]) => {
            formData.append(key, value as any);
        });
        try {
            const response = await updateCustomerService(TOKEN, id, formData);
            if (response.status === "success") {
                setIsLoading(false);
                setIsAlertModalOpen(true);
            } else {
                setIsLoading(false);
                setError('Failed to update customer information. Please check credentials and try again.');
            }
        } catch (error: any) {
            setIsLoading(false);
            setError(`Customer update failed. ${error.message}`);
            console.error('Customer update failed:', error);
        }
    };

    return (
        <AppLayout
            pageId={"Customer-List"}
            pageTitle={"Edit Customer"}
        >
            <EditCustomerWrapper>
                {/* alert modal below */}
                <BaseAlertModal
                    open={isAlertModalOpen}
                    icon={<AlertModalCheckIcon />}
                    title="Customer Successfully Updated"
                    message="Your information has been successfully added to the system."
                    callToAction="Back to Customer List"
                    handleClose={handleAlertModalPersist}
                    handleCallToAction={handleAlertModalCallToActionClick}
                />
                {/* alert modal above */}
                <Box>
                    <Typography
                        variant="h3"
                        fontFamily={"Poppins"}
                        fontWeight={700}
                        fontSize={20}
                        lineHeight={"normal"}
                        color="var(--dark-color)"
                    >
                        Choose an account type.
                    </Typography>
                </Box>
                <UpdateCustomer
                    error={error}
                    isLoading={isLoading}
                    handleSubmit={handleSubmit}
                    formDetails={formDetails}
                    setFormDetails={setFormDetails}
                    customerId={id}
                />
            </EditCustomerWrapper>
        </AppLayout>
    )
}